import axios from "axios";
import { ApiResponse } from "@api/apiRequest";
import { tpApi } from "@api/instances";
import { FeatureFlagsResponse } from "@appTypes/index";
import rollbar, { LogMetadata } from "@utils/rollbar";

const getFeatureFlags = async (signal?: AbortSignal): Promise<ApiResponse<FeatureFlagsResponse>> => {
  try {
    const response = await tpApi.get<FeatureFlagsResponse>("/users/v1/featureflags", {
      signal,
      requireAuth: true,
    });
    return { data: response.data, success: true, error: "" };
  } catch (e) {
    if (axios.isCancel(e)) {
      return { data: null, success: false, error: "AbortError" };
    }
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint: "/users/v1/featureflags", method: "GET" };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Error fetching feature flags" };
  }
};

export default getFeatureFlags;
